import RoutesInterface from './RoutesInterface';
import { getServices } from '../../../infra/commonInitializer';
import { RoutesInterfaceType, RouteType } from '@clientos/types';

let routesInterface: RoutesInterface;

export function getRoutesInterface(): RoutesInterface {
  return routesInterface;
}

export default async function initializeRoutesInterface(): Promise<RoutesInterfaceType> {
  if (routesInterface) return routesInterface.getInterface();

  const services = getServices();
  const { routesService } = services;

  routesInterface = new RoutesInterface({ routesService });

  return routesInterface.getInterface();
}

export function createNoopRoutesInterface(): RoutesInterfaceType {
  return {
    getRoutes: function (): RouteType[] {
      console.debug('Function not implemented.');
      return [];
    },
    findRouteByKey: function (): RouteType {
      console.debug('Function not implemented.');
      return {};
    },
    findRouteByPath: function (): RouteType {
      console.debug('Function not implemented.');
      return {};
    }
  };
}
